// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21pB8","colBig":"styles_colBig__16mIX","colSmall":"styles_colSmall__1NlES"};